module.exports = __webpack_public_path__ + "static/media/hellboy-static.4bcfbdaa.png";